// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanrequestconsts.proto (package aurora.core.consts.contractrequest, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanrequestconsts.proto.
 */
export const file_consts_loanrequestconsts: GenFile = /*@__PURE__*/
  fileDesc("Ch5jb25zdHMvbG9hbnJlcXVlc3Rjb25zdHMucHJvdG8SImF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdHJlcXVlc3QqfQoVQ29udHJhY3RSZXF1ZXN0U3RhdHVzEg8KC1VOU1BFQ0lGSUVEEAASCwoHUEVORElORxABEgwKCEFDQ0VQVEVEEAISDAoIUkVKRUNURUQQAxILCgdFWFBJUkVEEAQSDAoIQ0FOQ0VMRUQQBRIPCgtBVVRPTUFUQ0hFRBAGQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * possible states in the lifecycle of a contract request
 *
 * @generated from enum aurora.core.consts.contractrequest.ContractRequestStatus
 */
export enum ContractRequestStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * @generated from enum value: CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: AUTOMATCHED = 6;
   */
  AUTOMATCHED = 6,
}

/**
 * Describes the enum aurora.core.consts.contractrequest.ContractRequestStatus.
 */
export const ContractRequestStatusSchema: GenEnum<ContractRequestStatus> = /*@__PURE__*/
  enumDesc(file_consts_loanrequestconsts, 0);

